import { call, spawn } from "redux-saga/effects";
import { authSaga } from "./auth/authSaga";
import { classesSaga } from "./classes/classesSaga";
import { queueSaga } from "./queue/queueSaga";
import { registrationSaga } from "./registration/registrationSaga";
import { financialSaga } from "./financial/financialSaga";

/**
 * Wrapper auto-restart saga nếu watcher throw uncaught exception.
 * Bảo vệ root khỏi crash khi 1 worker lỗi đột ngột.
 */
function* safeSaga(saga: () => Generator): any {
    try {
        yield call(saga);
    } catch (e) {
        yield call(safeSaga, saga);
    }
}

export default function* rootSaga() {
    const sagas = [authSaga, classesSaga, queueSaga, registrationSaga, financialSaga];
    for (const saga of sagas) {
        yield spawn(safeSaga, saga);
    }
}
